import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'math-avg', 'MathAvg', [["path",{"d":"M3 21l18 -18"}],["path",{"d":"M4 12a8 8 0 1 0 16 0a8 8 0 1 0 -16 0"}]]);